import { useSelector } from 'react-redux';
import { getCurrentDragItem, getCurrentDropTarget, getDeepestHoveredNodePositionInfo, getDragItemIsHidden, getNodePositionsByTreeId } from 'InpageEditorUI/redux/selectors/layoutSectionDndSelectors';
import { getAllGridLayoutTreesAsMap } from 'ContentEditorUI/redux/selectors/moduleSelectors';
import { layoutNodeTypes } from 'layout-dnd-utils/constants/dndAreaHoverPositionConstants';
import { getImmutableOrPlain } from 'ContentEditorUI/utils/dataHelpers';
import { getActiveBreakpointName } from 'ContentEditorUI/redux/selectors/styleBreakpointsSelectors';
import { dropTypes } from 'ContentEditorUI/lib/layouts/constants';
import GridOverlay, { NEXT_FREE_CELL_ID } from './GridOverlay';
import { DRAG_TYPES } from 'layout-dnd-utils/constants/dnd';
import { DRAG_TYPES as CEUI_DRAG_TYPES } from 'ContentEditorUI/utils/DragAndDropConstants';
import { jsx as _jsx } from "react/jsx-runtime";
function useGetCurrentGridContainerNode() {
  var _containerNode, _containerNode2;
  const hoveredNodeInfo = useSelector(getDeepestHoveredNodePositionInfo);
  const gridLayoutTrees = useSelector(getAllGridLayoutTreesAsMap);
  const activeBreakpointName = useSelector(getActiveBreakpointName);
  const currentDragItem = useSelector(getCurrentDragItem);
  if (!hoveredNodeInfo) {
    return null;
  }
  let containerNode = null;
  if (currentDragItem && currentDragItem.dragType === DRAG_TYPES.EXISTING_ITEM) {
    const gridLayoutTree = gridLayoutTrees[currentDragItem.originLayoutSectionId];
    if (!gridLayoutTree || !gridLayoutTree.hasContainer(currentDragItem.parentId)) {
      return null;
    }
    containerNode = gridLayoutTree.findContainer(currentDragItem.parentId);
  } else if (currentDragItem && currentDragItem.dragType === CEUI_DRAG_TYPES.ADD_MODULE) {
    if (hoveredNodeInfo.type === layoutNodeTypes.PEGBOARD) {
      const gridLayoutTree = gridLayoutTrees[hoveredNodeInfo.gridLayoutId];
      if (!gridLayoutTree || !gridLayoutTree.hasContainer(hoveredNodeInfo.id)) {
        return null;
      }
      containerNode = gridLayoutTree.findContainer(hoveredNodeInfo.id);
    } else if (hoveredNodeInfo.type !== layoutNodeTypes.GRID_LAYOUT_ROOT) {
      const gridLayoutTree = gridLayoutTrees[hoveredNodeInfo.gridLayoutId];
      if (!gridLayoutTree || !gridLayoutTree.hasContainer(hoveredNodeInfo.parentId)) {
        return null;
      }
      containerNode = gridLayoutTree.findContainer(hoveredNodeInfo.parentId);
    }
  }
  if (hoveredNodeInfo.type === layoutNodeTypes.GRID_LAYOUT_GRID) {
    const gridLayoutTree = gridLayoutTrees[hoveredNodeInfo.gridLayoutId];
    if (!gridLayoutTree || !gridLayoutTree.hasContainer(hoveredNodeInfo.id)) {
      return null;
    }
    containerNode = gridLayoutTree.findContainer(hoveredNodeInfo.id);
  } else if (hoveredNodeInfo.isGridCell && hoveredNodeInfo.type !== layoutNodeTypes.GRID_LAYOUT_ROOT && hoveredNodeInfo.gridLayoutId && hoveredNodeInfo.parentId) {
    const gridLayoutTree = gridLayoutTrees[hoveredNodeInfo.gridLayoutId];
    if (!gridLayoutTree || !gridLayoutTree.hasContainer(hoveredNodeInfo.parentId)) {
      return null;
    }
    containerNode = gridLayoutTree.findContainer(hoveredNodeInfo.parentId);
  }
  const isGridTableOrPegboard = ((_containerNode = containerNode) === null || _containerNode === void 0 ? void 0 : _containerNode.isGrid(activeBreakpointName)) || ((_containerNode2 = containerNode) === null || _containerNode2 === void 0 ? void 0 : _containerNode2.isPegboard(activeBreakpointName));
  return isGridTableOrPegboard ? containerNode : null;
}
function useGetTargetedGridCellId() {
  const currentDropTarget = useSelector(state => getCurrentDropTarget(state));
  const dragItemIsHidden = useSelector(state => getDragItemIsHidden(state));
  if (!currentDropTarget || dragItemIsHidden) {
    return null;
  }
  const type = getImmutableOrPlain(currentDropTarget, 'type');
  switch (type) {
    case dropTypes.APPEND_GRID_CELL:
      return NEXT_FREE_CELL_ID;
    case dropTypes.INSERT_INTO_TABLE_CELL:
      return getImmutableOrPlain(currentDropTarget, 'targetedCellId');
    case dropTypes.INSERT_AFTER_TABLE_CELL:
      return getImmutableOrPlain(currentDropTarget, 'nextSiblingId');
    default:
      return null;
  }
}
export default function GridDndOverlayContainer() {
  const nodePositionsByTreeId = useSelector(getNodePositionsByTreeId);
  const activeBreakpointName = useSelector(getActiveBreakpointName);
  const targetedGridCellId = useGetTargetedGridCellId();
  const currentGridContainerNode = useGetCurrentGridContainerNode();
  if (currentGridContainerNode) {
    const gridNodeContainerNodePositions = nodePositionsByTreeId[currentGridContainerNode.getRootId()][currentGridContainerNode.getId()];
    return /*#__PURE__*/_jsx(GridOverlay, {
      targetedGridCellId: targetedGridCellId,
      gridContainerNode: currentGridContainerNode,
      activeBreakpointName: activeBreakpointName,
      top: gridNodeContainerNodePositions.top,
      left: gridNodeContainerNodePositions.left
    });
  }
  return null;
}